import type { ReactNode } from "react";
import { Card } from "@/components/ui/Card";
import { EmptyState, ErrorState, TableSkeleton } from "@/components/ui/States";

/**
 * The shape every list screen in this console has: a filter row, a panel
 * with a table in it, and the three states that panel can be in.
 *
 * It exists so those three states are decided ONCE. Left to each screen,
 * "empty" quietly becomes "a table with a header and no rows", which looks
 * identical to "still loading" for the half-second that matters.
 */
export function ListScaffold({
  filters,
  isLoading,
  isError,
  onRetry,
  isEmpty,
  emptyTitle,
  emptyHint,
  children,
  footer,
}: {
  filters?: ReactNode;
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
  isEmpty: boolean;
  emptyTitle: string;
  emptyHint?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-3">
      {filters ? (
        <div className="flex flex-wrap items-end gap-2">{filters}</div>
      ) : null}
      <Card padded={false} className="overflow-hidden">
        {isError ? (
          <ErrorState onRetry={onRetry} />
        ) : isLoading ? (
          <TableSkeleton />
        ) : isEmpty ? (
          <EmptyState title={emptyTitle} hint={emptyHint} />
        ) : (
          children
        )}
      </Card>
      {footer}
    </div>
  );
}
